import React from 'react';
import { connect } from 'react-redux';
import CartPaymentInfoItem from './common/CartPaymentInfoItem';
import { cartInfoUpdate } from '../../actions/cart';
import { setCartPanel } from '../../actions/panels';

class SelectPayment extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="payment-options-wrapper">
                <h1>Select Payment Method</h1>
                <div className="update-payment-button-container">
                    <a
                        // Image in here ....
                        className="account-button in-receipt usual-orders"
                        onClick={() => { 
                            this.props.dispatch(cartInfoUpdate({prop: 'saved_card', value: 0}));
                            this.props.dispatch(cartInfoUpdate({prop: 'saved_card_name', value: ''}));
                            this.props.dispatch(cartInfoUpdate({prop: 'viewCCInfo', value: true}));
                            this.props.dispatch(setCartPanel('checkout'));
                        }}
                    >
                        {/* <CardIcon style={styles.buttonIconWhite}  fill="#fff"  width="20" height="20" /> */}
                        <span className="cc-button-text">Use Different Card</span>
                    </a>
                </div>
                {this.props.user.paymentInfo.map((info, index) => {
                    return (
                        <CartPaymentInfoItem 
                            key={"ccinfo-"+index}
                            title={info.name}
                            onButtonPress={() => { 
                                this.props.dispatch(cartInfoUpdate({prop: 'saved_card', value: info.id}));
                                this.props.dispatch(cartInfoUpdate({prop: 'saved_card_name', value: info.name}));
                                this.props.dispatch(cartInfoUpdate({prop: 'viewCCInfo', value: false}));
                                this.props.dispatch(setCartPanel('checkout'));
                            }}
                        />
                    );
                })}
            </div>
        );
    }
}

// const styles = StyleSheet.create({
//     container: {
//         flex: 1,
//         backgroundColor: '#FFFFFF',
//     },
//     selectCardHeading: {
//         flexDirection: 'row',
//         paddingTop: 20,
//         marginBottom: 10,
//         paddingBottom: 10, 
//         textTransform: 'none',
//         marginBottom: 5, 
//         fontSize: 22, 
//         lineHeight: 30, 
//         fontWeight: 'bold'
//     },
//     buttonUpdatePayment: {
//         padding:13,
//          backgroundColor: 'white',
//          paddingRight: 50,
//          paddingLeft: 50,
//          borderRadius: 20,
//          flexDirection: 'row',
//          marginTop: 5, 
//          marginBottom: 5, 
//          alignItems: 'center',
//          justifyContent: 'center',
//          color:'red',
//          backgroundColor: '#3a81b7',
//          fontSize: 14,
//          fontWeight: '700',
//          textAlign: 'center',
//          zIndex: 100,
//          paddingBottom: 10   
//      },
//      paymentOptionWrapper:{
//         paddingHorizontal: 20
//      },
//     updateCreditCardButtonText: {
//         fontSize: 14, 
//         fontWeight: '700',
//         textAlign: 'center',
//         letterSpacing: 1,
//          textTransform: 'none',
//          color: 'white',
//     },
//     buttonIconWhite: {
//         flexDirection: 'row',
//         height: 15, 
//         marginRight: 10,
//     },
//     updatePaymentButtonContainer: {
//         paddingBottom: 20,
//     }
// });

const mapStateToProps = (state) => {

    return {
        user: state.auth.user,
        token: state.auth.token,
        loading: state.auth.loading
    };
};

export default connect(mapStateToProps)(SelectPayment);
